export default __webpack_public_path__ + "static/media/15.6a773f73.png";